var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrayVehicle = function SvgGrayVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1871_10720)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1871_10720)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 22V10",
    stroke: "white",
    strokeWidth: 0.904157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16L24 16",
    stroke: "white",
    strokeWidth: 0.904157
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2852,
    y: 14.2856,
    width: 3.42857,
    height: 3.42857,
    fill: "#767676",
    stroke: "white",
    strokeWidth: 0.904157
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1871_10720",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.286275 0 0 0 0 0.286275 0 0 0 0 0.286275 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1871_10720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1871_10720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1871_10720"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
};
export { SvgGrayVehicle as ReactComponent };
export default __webpack_public_path__ + "assets/e0b5e9c9.svg";